
/** Arredonda um número conforme a precisão informada */
export function toFixed(value, precision: number): number {
    value = value && !isNaN(value) ? Number(value) : 0;
    precision = precision && !isNaN(precision) ? Number(precision) : 0;

    const factor = Math.pow(10, precision);
    const result = (Math.round(value * factor) / factor).toFixed(precision);
    return Number(result);
}


/**
 * Arredonda pelo valor binário real, e não pelo produto `value * 10 ** precision` como o `toFixed`:
 * `0.615` a 2 casas dá `0.61` aqui e `0.62` lá. É o mesmo critério do back-end.
 */
export function toFixedExact(value, precision: number): number {
    value = value && !isNaN(value) ? Number(value) : 0;
    precision = precision && !isNaN(precision) ? Number(precision) : 0;

    return Number(value.toFixed(precision));
}


/** Verifica se o número informado é um número par */
export function isEven(value: number): boolean {
    if (value % 2 === 0) {
        return true;
    }

    return false;
}

/** Verifica se o número informado é um número ímpar' */
export function isOdd(value: number): boolean {
    return !isEven(value);
}
